import React, {useCallback} from "react";
import {ReportManagement} from "../../../components";
import {sendSystemReport} from "../../../api/report/report.js";
import {systemReports} from "./consts.js";

export const SystemReports = () => {
    const onSave = useCallback(async values => {
        const {reportName, params} = values;
        const response = await sendSystemReport(reportName, params);
        return !response?.error;
    }, []);

    return (
        <>
            <ReportManagement reports={systemReports} onSave={onSave} />
        </>
    );
};
